import Joi from "joi";
import React, { Component, createRef } from "react";
import { toast } from "react-toastify";
import "../../include/css/bootstrap.min.css";
import "../../include/css/style.css";
import "../../include/css/dev.css";
import LoadingBar from "react-top-loading-bar";
import { login } from "../../actions/memberAction";
import { Link, navigate } from "gatsby";
import { validateErrorMessage } from "../../components/common/validation";
import { SEO } from "../../components/seo";
import Footer from "../../components/common/footerOnboarding";
import AlertError from "../../components/common/alertError";
import { parse } from "query-string";
import FetchImage from "../../components/common/fetchImage";
import { isMobile } from "react-device-detect";

class Login extends Component {
  ref = createRef(null);

  state = {
    loading: false,
    isSessionOut: false,
    eyes: false,
    redirectUrl: "",
    isAviation: false,
    data: {
      email: "",
      password: "",
    },
    errors: "",
  };
  schema = Joi.object({
    password: Joi.string()
      .required()
      .error((errors) => validateErrorMessage(errors)),
    email: Joi.string()
      .email({ tlds: { allow: false } })
      .required()
      .error((errors) => validateErrorMessage(errors)),
  });
  validate = () => {
    const error = this.schema.validate(this.state.data, { abortEarly: false });
    if (error.error && error.error.details) {
      const errors = {};
      error.error.details.forEach((element) => {
        errors[element.context.key] = element.message;
      });
      this.setState({ errors });
      return false;
    }
    this.setState({ errors: "" });
    return true;
  };

  doSubmit = (event) => {
    if (this.validate()) {
      this.ref.current.continuousStart();
      const { email, password } = this.state.data;

      const payLoad = {
        email,
        password: password,
      };
      this.setState({ loading: true });
      login(payLoad, (res) => {
        this.ref.current.complete();
        this.setState({ loading: false });
        if (res.status === 200) {
          if (typeof window !== "undefined") {
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("refreshToken", res.data.refreshToken);
            localStorage.setItem("member", JSON.stringify(res.data));
            localStorage.setItem(
              "customization",
              JSON.stringify({
                dashboard_color: res?.data?.dashboard_color,
                dashboard_secondary_color: res?.data?.dashboard_secondary_color,
                show_custom_dashboard: res?.data?.show_custom_dashboard,
                dashboard_logo: res?.data?.dashboard_logo,
                is_logo_white: res?.data?.is_logo_white,
              }),
            );
          }
          if (this.state.redirectUrl) {
            window.location.href = `${this.state.redirectUrl}`;
          } else if (typeof window !== "undefined") {
            window.location.href = localStorage.getItem("redirectUrl") ? localStorage.getItem("redirectUrl") : "/";
            localStorage.removeItem("redirectUrl");
          }
        } else {
          toast(<AlertError message="Invalid Email or Password" />);
        }
      });
    }
  };

  onChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const data = { ...this.state.data };
    data[name] = value;
    this.setState({ data });
  };
  componentDidMount() {
    document.body.classList.add("p-0");
    const data = parse(this.props.location.search);
    if (data.session_timeout) {
      this.setState({ isSessionOut: true });
    }
    if (this.props.location.state?.isRedirect == "fromEiPage" && typeof window !== "undefined") {
      const url = `/members/post-listing/?redirect=${btoa(`page=fromEiPage`)}`;
      this.setState({ redirectUrl: url });
    } else if (this.props.location.state?.isRedirect == "fromPage" && typeof window !== "undefined") {
      const url = `/members/post-listing/?redirect=${btoa(`page=fromPage`)}`;
      this.setState({ redirectUrl: url });
    } else if (data?.redirect?.length > 0) {
      const value = data?.redirect ? atob(data?.redirect) : "";
      const parsedData = value ? parse(value) : "";
      if (parsedData?.isSessionTimeout) {
        if (typeof window !== "undefined" && parsedData?.page === "invoice") {
          window.localStorage.removeItem("token");
          window.localStorage.removeItem("member");
          window.localStorage.removeItem("buyerInspectionClosed");
          window.localStorage.removeItem("buyerInspectionDate");
          window.localStorage.removeItem("mimictoken");
          window.localStorage.removeItem("mimicmember");
          localStorage.setItem("redirectUrl", "/my-account/invoices/");
        }
      }
    }
  }

  componentWillUnmount() {
    document.body.classList.remove("p-0");
  }

  render() {
    const { errors, data } = this.state;
    const fabIco = process.env.GATSBY_IMAGE_URL + "favicon.png";

    return (
      <>
        <LoadingBar color="#47AD1D" ref={this.ref} />
        <div class="header d-flex align-items-center justify-content-center">
          <div class="logo-area">
            <Link to="/" className="logo-box">
              <FetchImage image="logo.svg" className="d-none d-lg-block" />
              <FetchImage image="salvex-logo.svg" className="d-block d-lg-none" />
            </Link>
          </div>
        </div>
        <div class="member-outer white-bg">
          <div class="member-container">
            {this.state.isSessionOut ? (
              <div className="text-center member-intro-box session-timeout">
                <p>
                  Your session has expired. Please log in again.
                  <br />
                  <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => navigate("/")}>
                    Click here to visit home page
                  </span>
                </p>
              </div>
            ) : (
              ""
            )}
            <div class="member-intro-box text-center">
              <h1>Member Login</h1>
            </div>
            <div class="member-content member-login">
              <div class="member-form-box mx-auto border-radious-10">
                <div class="form-group">
                  <label for="email" class="form-label">
                    Email Address
                  </label>
                  <input
                    type="email"
                    name="email"
                    class="form-control"
                    id="email"
                    onChange={this.onChange}
                    value={data.email}
                  />{" "}
                  {errors.email && <label className="error">{errors.email}</label>}
                </div>
                <div class="form-group">
                  <label for="password" class="form-label">
                    Password
                  </label>
                  <div class="input-group">
                    <input
                      type={this.state.eyes ? "text" : "password"}
                      id="passwd"
                      name="password"
                      class="form-control"
                      onChange={this.onChange}
                      value={data.password}
                    />
                    <div class="eye-icon-box">
                      {!this.state.eyes ? (
                        <img
                          src={process.env.GATSBY_IMAGE_URL + "eye-off.svg"}
                          onClick={() => this.setState({ eyes: true })}
                          alt="eye-off"
                        />
                      ) : (
                        <img
                          src={process.env.GATSBY_IMAGE_URL + "eye.svg"}
                          onClick={() => this.setState({ eyes: false })}
                          alt="eye"
                        />
                      )}
                    </div>
                  </div>
                  {errors.password && <label className="error">{errors.password}</label>}
                </div>
                <div class="form-group remember-me-row d-flex flex-wrap align-items-center justify-content-between">
                  <div class="form-check d-flex align-items-center">
                    <input class="form-check-input" type="checkbox" value="" id="rememberMe" />
                    <label class="form-check-label" for="rememberMe">
                      Remember me
                    </label>
                  </div>
                  <Link to="/members/forgot-password">Forgot your password?</Link>
                </div>
                <div class="form-group form-button">
                  <input
                    type="submit"
                    name="submit"
                    class={
                      this.state.loading
                        ? "btn btn-default btn-xl btn-block disabled"
                        : "btn btn-default btn-xl btn-block"
                    }
                    value="Login"
                    onClick={(e) => this.doSubmit(e)}
                  />
                </div>
                <div class="login-link">
                  Not a Member?{" "}
                  <Link to="/members/register">
                    {" "}
                    <strong>Register</strong>
                  </Link>
                </div>
                <div class="login-link" style={{ marginTop: "20px" }}>
                  <Link to="/" style={{ textDecoration: "underline" }}>
                    Click here
                  </Link>
                  &nbsp; to go back to home page
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </>
    );
  }
}

export default Login;

export const Head = ({ location }) => (
  <SEO title={"Login | Salvex"} canonical={`https://www.salvex.com${location.pathname}`} />
);
